const COLOURS = {
  mono: {
    black: '#000',
    black10: 'rgba(0, 0, 0, 0.1)',
    black25: 'rgba(0, 0, 0, 0.25)',
    black50: 'rgba(0, 0, 0, 0.5)',
    black75: 'rgba(0, 0, 0, 0.75)',
    white: '#fff',
    white25: 'rgba(255,255,255,0.25)',
    white50: 'rgba(255,255,255,0.50)',
    white75: 'rgba(255,255,255,0.75)',
    offwhite35: 'rgba(220, 220, 240, 0.35)',
    offwhite15: 'rgba(249, 249, 251, 0.15)',
    ghostWhite: '#F2F3F8'
  },
  cyan: {
    turquoise: '#2BD0B3',
    turquoiseLight: 'rgba(4, 178, 182, 0.1)',
    aqua: '#2ACFB3',
    aquaDark: '#469999',
    jungleGreen: {
      monkey: '#27BAA1',
      monkey25: 'rgba(39, 186, 161, 0.25)',
      parrot: '#23A68F',
      monkeyLight: '#D4F2EC'
    },
    bermudaBlue: '#2A9F8B',
    cast: '#4EAFB4',
    deepJungleGreen: '#258777'
  },
  grey: {
    codGrey: '#111111',
    nero: '#151515',
    coalMine: '#222222',
    mineShaft: '#262626',
    excavator: '#2D2D2D',
    nightRider: '#333333',
    denim: '#323A45',
    lightDenim: '#4B5868',
    darkDenim: '#1A1F24',
    grayCharcoal: '#323A45',
    grayCharcoalDark: '#1A1f24',
    darkDenim50: 'rgba(26, 31, 36, 0.5)',
    darkDenim75: 'rgba(26, 31, 36, 0.75)',
    tundora: '#474747',
    raspingSandy: '#555555',
    sterling: '#EAEDF2',
    athens: {
      parthenon: '#F4F6FA',
      zeus: '#F5F6F8',
      bigFat: '#E8ECF0',
      smallSkinny: '#CBDFF2'
    },
    catSkillWhite: '#FAFAFB',
    mischka: {
      russian: '#D4D9E2',
      michael: '#CBD0DB'
    },
    dusty: '#979797',
    nevada: '#696D74',
    jumbo: '#7A7A7B',
    regent: '#8C96A9',
    slateBlueGray: '#515E71',
    regent50: 'rgba(140,150,169,0.5)',
    grayBrown: '#6F6866',
    navMenuAdmin: '#474A52',
    navMenuAdminHover: '#313238',
    navMenuLabel: '#c4cad7'
  },
  red: {
    thunderBird: '#BE1C22',
    alizarinCrimson: '#DD1F26',
    redApple: '#BE1D22',
    bloody: '#C82907'
  },
  yellow: {
    goldenTainoi: '#FFC850',
    dandelion: '#FFDC64',
    goldenShiny: '#FFCE44',
    lightYellow: '#F8F1D6'
  },
  green: {
    greenSnake: '#6abd45',
    lightGreen: '#E3F4F1'
  },
  orange: {
    mandarin: '#FE8200'
  },
  userComment: {
    cerulean: '#27BAA1',
    heartfeltVermillion: '#ff1100',
    unsafeOchre: '#F69F1F',
    snapMint: '#50ff03',
    shallowOrchid: '#F118F8',
    archetypal: '#0A84FF',
    horseDrawnPansy: '#A65AF2',
    gulliblePlatinum: '#cffaf6',
    diamond: '#01828E',
    lightGrass: '#06C5AB'
  },
  pink: {
    internalPink: '#FF3366'
  },
  blue: {
    deepCerulean: '#006CB2',
    azureRadiance: '#008BE5',
    orient: '#005790',
    darkSea: '#2061F7',
    steelBlueGray: '#69839D'
  },
  purple: {
    purple: '#7A66FF',
    purple25: '#F3F1FF',
    lightPurple: '#A520F7'
  }
};

const FONT_SIZES = {
  micro: '10px',
  small: '12px',
  default: '14px',
  phone: '16px',
  semilarge: '18px',
  large: '20px'
};

const FONT_WEIGHTS = {
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700
};

const SHADOWS = {
  default: '0 2px 4px 0 rgba(140, 150, 169, 0.5)',
  soft: '0 6px 20px 0 rgba(13, 51, 32, 0.1)',
  softElevated: '0 6px 20px 0 rgba(13, 51, 32, 0.2)'
};

const NAVIGATION_MENU_SIZE = {
  default: 250
};

const HEADER = {
  height: '60px',
  pageHeight: '100px',
  zIndex: 6,
  indentHorizontal: '40px',
  menuMobileIconWidth: '70px'
};

const DRAWER = {
  indent: '20px'
};

const NUMERIC_MEDIA_SIZES = {
  small: 639,
  medium: 1023,
  large: 1600,
  xlarge: 2048
};

const MEDIA_SIZES = Object.keys(NUMERIC_MEDIA_SIZES).reduce(
  (mediaSizes, sizeName) => ({ ...mediaSizes, [sizeName]: `${NUMERIC_MEDIA_SIZES[sizeName]}px` }),
  {}
);

const NUMERIC_MEDIA_RANGES = {
  smallMin: 0,
  smallMax: NUMERIC_MEDIA_SIZES.small,
  mediumMin: NUMERIC_MEDIA_SIZES.small + 1,
  mediumMax: NUMERIC_MEDIA_SIZES.medium,
  largeMin: NUMERIC_MEDIA_SIZES.medium + 1,
  largeMax: NUMERIC_MEDIA_SIZES.large,
  xlargeMin: NUMERIC_MEDIA_SIZES.large + 1,
  xlargeMax: 9999999
};

const MEDIA_RANGES = Object.keys(NUMERIC_MEDIA_RANGES).reduce(
  (mediaSizes, sizeName) => ({ ...mediaSizes, [sizeName]: `${NUMERIC_MEDIA_RANGES[sizeName]}${NUMERIC_MEDIA_RANGES[sizeName] === 0 ? '' : 'px'}` }),
  {}
);

const MEDIA_QUERIES = {
  small: `@media screen and (max-width: ${MEDIA_SIZES.small})`,
  medium: `@media screen and (max-width: ${MEDIA_SIZES.medium})`,
  mediumUp: `@media screen and (min-width: ${MEDIA_RANGES.mediumMin})`,
  large: `@media screen and (max-width: ${MEDIA_SIZES.large})`,
  largeUp: `@media screen and (min-width: ${MEDIA_RANGES.largeMin})`,
  xlarge: `@media screen and (max-width: ${MEDIA_SIZES.xlarge})`
};

// The colours are flattened so that they can be accessed via dot notation as follows
// FLATTENED_COLOURS.regent
const FLATTENED_COLOURS = Object.assign(
  {},
  ...function _flatten(o) {
    return [].concat(...Object.keys(o)
    // $FlowFixMe
    .map((k) => typeof o[k] === 'object' ?
    _flatten(o[k]) :
    { [k]: o[k] }
    )
    );
  }(COLOURS)
);

export {
  COLOURS,
  FONT_SIZES,
  FONT_WEIGHTS,
  MEDIA_SIZES,
  NAVIGATION_MENU_SIZE,
  HEADER,
  DRAWER,
  NUMERIC_MEDIA_SIZES,
  MEDIA_QUERIES,
  MEDIA_RANGES,
  FLATTENED_COLOURS,
  SHADOWS };